import { Injectable, inject } from '@angular/core';
import {ApiProvider, ApiProviderConfig} from './api-provider';
import {HttpClient} from '@angular/common/http';
import {CacheService} from '../../cache/cache.service';
import {Router, UrlSerializer} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ApiProviderFactoryService {
  private _http = inject(HttpClient);
  private _cache = inject(CacheService);
  private _router = inject(Router);
  private _urlSerializer = inject(UrlSerializer);


  create(config: ApiProviderConfig): ApiProvider {
    return new ApiProvider(config, {
      _http: this._http,
      _cache: this._cache,
      _router: this._router,
      _urlSerializer: this._urlSerializer
    });
  }
}
